//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import Utils from '@/utils/global-utils'
import HelpWalletDialog from '@/components/HelpWalletDialog'

export default {
  components: {
    HelpWalletDialog,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: String,
      default: '',
    },
    activator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    localEnd() {
      return moment(this.project.end_at).toLocaleString()
    },
    tokenLimit() {
      return Utils.number2words(this.project.tokens_per_wallet)
    },
    revealDelay() {
      return Utils.number2words(this.project.reveal_delay)
    }
  },
  methods: {
    handleOpenWallet() {
      this.$refs.walletDialog.handleOpen()
    },
    handleOpen() {
      this.dialog = true
    },
  },
}
